/**
 * The day key the driving report is indexed by (#300).
 *
 * The backend groups `daily_hours` in `Europe/Lisbon` (`REPORT_TZ` in
 * `reports/views.py`) — the report is a Portuguese legal document and its days
 * are Portuguese days. The app used to build the key with
 * `new Date().toISOString().split('T')[0]`, which is the **UTC** date.
 *
 * The two agree for most of the day and disagree for exactly one hour: in
 * summer Lisbon is UTC+1, so between 23:00 and midnight UTC the backend has
 * already moved to tomorrow while the app is still asking for today. The lookup
 * misses, `daily_hours[today]` falls back to the empty default, and the driver
 * sees a report with no events after a session the app had just confirmed.
 *
 * That is not hypothetical: it took down `e2e-mobile-driver-single-video` on a
 * run that started at 23:12 UTC, with every step of the flow green.
 *
 * Using the device's own local date would be right for a driver in Portugal and
 * wrong for anyone else, so the zone is named explicitly — it must match the
 * backend, not the phone.
 */
export const REPORT_TIME_ZONE = 'Europe/Lisbon';

/**
 * `YYYY-MM-DD` for the given instant in the zone the report is grouped by.
 * `en-CA` is the locale whose short date format IS `YYYY-MM-DD`.
 */
export function reportDayKey(instant: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: REPORT_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(instant);
}
